export const CONTEXT_DATA_SET_IS_FETCHING_RESOURCES = 'ContextData/SetIsFetchingResources';
export const CONTEXT_DATA_SET_IS_FETCHING_PROVIDER_CONFIGS = 'ContextData/SetIsFetchingProviderConfigurations';
export const CONTEXT_DATA_SET_IS_FETCHING_BUSINESS_UNITS = 'ContextData/SetIsFetchingBusinessUnits';
export const CONTEXT_DATA_SET_IS_FETCHING_SFTP_FOLDERS = 'ContextData/SetIsFetchingSftpFolders';
export const CONTEXT_DATA_FETCH_RESOURCES = 'ContextData/FetchResources';
export const CONTEXT_DATA_FETCH_PROVIDER_CONFIGURATIONS_SUCCESS = 'ContextData/FetchProviderConfigurationsSuccess';
export const CONTEXT_DATA_FETCH_BUSINESS_UNITS_SUCCESS = 'ContextData/FetchBusinessUnitsSuccess';
export const CONTEXT_DATA_FETCH_SFTP_FOLDERS_SUCCESS = 'ContextData/FetchSftpFoldersSuccess';
export default {
    CONTEXT_DATA_FETCH_RESOURCES
};
